module.exports = __webpack_public_path__ + "static/media/A3.6d4bcea5.jpg";